export const SET_LANGUAGE = "set-language";
export const SET_AVAILABLE_LANGUAGES = "set-available-languages";
export const SET_ALL_AVAILABLE_LANGUAGES = "set-all-available-languages";
